export default __webpack_public_path__ + "static/media/icon03.f8a0b9be.png";